import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['token']

  tokenUpdate(event) {
    this.tokenTarget.value = event.detail.token
  }
}
